export { DMS_MODULE } from '../constants';
export const NAME = 'WmsWashingLabor';
export const API_NAME = 'WmsWashingLabor';
export const CRUMB_LABEL_KEY = 'WmsWashingLabor';
